import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'customers',
  path: '/systems/notification',
  title: 'Notification',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);